import { messageBoxButtons, messageBoxButtonsCaptionDefault } from '../../../main/constants';

import ModalWrapper from '../../../nextgen/common/ModalWrapper';
import PropTypes from 'prop-types';
import styles from './MessageBox.scss';

const MessageBox = ({
  onCancel,
  onOk,
  onClose,
  show,
  text,
  title = ' ',
  buttons = messageBoxButtons.ok, // Default value for buttons
  buttonsCaption = [...Object.values(messageBoxButtonsCaptionDefault)], // Default value for buttonsCaption
  closeButton,
}) => {
  //const { onCancel, onOk, onClose, show, text, buttons, buttonsCaption, closeButton } = props;
  const cancelHandler = (e) => {
    e.stopPropagation();
    onCancel();
  };
  const okHandler = (e) => {
    e.stopPropagation();
    onOk();
  };
  const closeHandler = (e) => {
    e.stopPropagation();
    onClose();
  };
  const okButtonText =
    buttonsCaption && buttonsCaption.length > 0 ? buttonsCaption[0] : messageBoxButtonsCaptionDefault.ok;
  const cancelButtonText =
    buttonsCaption && buttonsCaption.length > 1 ? buttonsCaption[1] : messageBoxButtonsCaptionDefault.cancel;
  return (
    <>
      <ModalWrapper
        showModal={show}
        title={title}
        showClose={closeButton}
        closeHandler={closeHandler}
        restoreFocus={false}
        className={styles['message-box']}
        primary={{ show: true, onClick: okHandler, text: okButtonText }}
        secondary={
          buttons !== messageBoxButtons.ok
            ? {
                show: buttons !== messageBoxButtons.ok,
                onClick: cancelHandler,
                text: cancelButtonText,
              }
            : null
        }>
        {text}
      </ModalWrapper>
    </>
  );
};

MessageBox.propTypes = {
  buttons: PropTypes.oneOf([...Object.values(messageBoxButtons)]),
  buttonsCaption: PropTypes.array,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onCancel: PropTypes.func,
  onOk: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
};
// MessageBox.defaultProps = {
//   buttons: messageBoxButtons.ok,
//   buttonsCaption: [...Object.values(messageBoxButtonsCaptionDefault)],
// };

export default MessageBox;
